import type { ToolsModalItemType } from "../../../common-deprecated/features/new-cars/debug-modal/components/ToolsModal";
import { useCompareV2Selector } from "../redux/store";
import { getComparePDFLink } from "../utils/utils";

const useNcCompareTools = (): ToolsModalItemType[] => {
    const commonSettings = useCompareV2Selector((state) => state.commonSettings);
    const compareContext = useCompareV2Selector((state) => state.newCarCompare.ncCompareContext);
    const available = useCompareV2Selector((state) => state.newCarCompare.available || []);
    const url = getComparePDFLink(commonSettings, compareContext, available);

    return [{ links: [{ title: "Direct link to PDF", href: url }] }];
};

export default useNcCompareTools;
